import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from 'src/components/CustomButton/CustomButton';

import '../modals.scss';

export const DeleteModal = ({ title, onConfirm, onCancel }) => {
  const { t } = useTranslation('modal');

  return (
    <div className="modal__backdrop">
      <div className="modal modal__delete">
        <h3>{title}</h3>

        <div className="modal__delete__footer">
          <CustomButton title={t('no')} variant="filled" color="red" onClick={onCancel} />
          <CustomButton title={t('yes')} variant="filled" color="green" onClick={onConfirm} />
        </div>
      </div>
    </div>
  );
};
